import style from "./Footer.module.css";

export default function Footer() {
  return (
    <div className={style.footerContainer}>
      <p>©2024 RAMDOM BURGUER SHOP</p>
      <p>DEVELOPED BY JEAN ALÓQUIO CELIN</p>
    </div>
  );
}
